import {
  MultiSelectProps,
  MultiSelect as MantineMultiSelect,
} from "@mantine/core"
import { forwardRef } from "react"

import classes from "./MultiSelect.module.css"

type Props = MultiSelectProps

export const MultiSelect = forwardRef<HTMLInputElement, Props>(
  ({ ...props }, ref) => {
    return <MantineMultiSelect {...props} classNames={classes} ref={ref} />
  }
)

MultiSelect.displayName = "MultiSelect"
